module.exports = __webpack_public_path__ + "static/media/minimal.50d.3f.552caac7.csv";